import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import ScrollIndicator from "../components/ScrollIndicator";

function RefundPolicy() {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    const { t } = useTranslation();
    const currentLanguage = i18n.language;

    const font = currentLanguage === "en" ? "Montserrat, Sans-serif" : "Tajawal, Sans-serif";

    return (
        <div className="w-full flex flex-col items-center justify-center py-[50px]">
            <ScrollIndicator />
            <div id="text-box" className="text-center mx-auto mb-10">
                <h1
                    className="text-[60px] leading-[1.3em] text-[#00001c] font-bold tracking-[-0.05em] py-5"
                    style={{ fontFamily: currentLanguage === "en" ? "Poppins, Sans-serif" : "Tajawal, Sans-serif" }}
                >
                    {t("refundHeader")}
                </h1>
            </div>

            {/* Eligibility Section */}
            <div id="eligibility" className="w-[85%]">
                <p className="text-[22px] font-medium mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("refundEligibilityTitle")}
                </p>
                <ol
                    className="flex flex-col text-justify mb-2.5 text-[16px] font-normal text-[#000024] px-10 list-disc w-[95%] gap-2"
                    style={{ fontFamily: font }}
                >
                    <li>{t("refundEligibility1")}</li>
                    <li>{t("refundEligibility2")}</li>
                    <li>{t("refundEligibility3")}</li>
                    <li>{t("refundEligibility4")}</li>
                    <li>{t("refundEligibility5")}</li>
                </ol>
            </div>

            {/* Request Instructions */}
            <div id="request" className="w-[85%] mt-6">
                <p className="text-[20px] font-medium mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("howToRequestRefund")}
                </p>
                <p className="text-[18px] font-normal mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("requestInstructions")}
                </p>
                <p className="text-[18px] font-normal mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("requestDetails")}
                </p>
            </div>

            {/* Processing Time */}
            <div id="processing" className="w-[85%] mt-6">
                <p className="text-[20px] font-medium mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("processingTime")}
                </p>
                <p className="text-[18px] font-normal mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("processingDetails")}
                </p>
                <p className="text-[18px] font-normal mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("refundMethod")}
                </p>
            </div>

            {/* Delays */}
            <div id="delays" className="w-[85%] mt-6">
                <p className="text-[20px] font-medium mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("delaysTitle")}
                </p>
                <ol
                    className="flex flex-col text-justify mb-2.5 text-[16px] font-normal text-[#000024] px-10 list-disc w-[95%] gap-2"
                    style={{ fontFamily: font }}
                >
                    <li>{t("checkBank")}</li>
                    <li>{t("contactBank")}</li>
                    <li>{t("waitPeriod")}</li>
                    <li>{t("contactSupport")}</li>
                </ol>
            </div>

            {/* Contact Us */}
            <div id="contact" className="w-[85%] mt-6">
                <p className="text-[22px] font-medium mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("contactUs")}
                </p>
                <p className="text-[18px] font-normal mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("contactDetails")}
                </p>
                <p className="text-[18px] font-normal mb-2 text-start text-[#000024]" style={{ fontFamily: font }}>
                    {t("businessHours")}
                </p>
            </div>
        </div>
    );
}

export default RefundPolicy;